// React hook for price polling (replaces useWebSocket)
// Provides access to polled ticker data and polling state

import { usePricePollingContext } from '../contexts/PricePollingProvider';
import type { Ticker } from '../types/mexc';

export interface PricePollingState {
    // Ticker data
    tickers: Record<string, Ticker>;

    // Polling state
    lastPollTime: number;
    nextPollTime: number;
    timeUntilNextPoll: number;
    isPolling: boolean;

    // Error state  
    error: string | null;

    // Actions
    forcePoll: () => Promise<void>;
}

export function usePricePolling(): PricePollingState {
    const context = usePricePollingContext();

    return {
        tickers: context.tickers,
        lastPollTime: context.lastPollTime,
        nextPollTime: context.nextPollTime,
        timeUntilNextPoll: context.timeUntilNextPoll,
        isPolling: context.isPolling,
        error: context.lastError,
        forcePoll: context.forcePoll,
    };
}
